<template>
  <div class="app">
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <!-- <breadcrumb :list="list"/> -->
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside/> -->
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Footer as AppFooter } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    // AppAside,
    AppFooter
    // Breadcrumb
  },
  watch: {
    '$route' (to, from) {
      document.body.classList.remove('sidebar-mobile-show')
    }
  },
  created () {
    this.projectPerson = localStorage.getItem('id_token_portal')
    if (this.projectPerson === null) {
      this.$router.push('/login')
    }
    if (localStorage.getItem('email') !== 'simon@imentor.dk' && localStorage.getItem('email') !== 'hossygf@gmail.com' && localStorage.getItem('email') !== 'pn@elternativet.dk' && localStorage.getItem('email') !== 'info@murermesterk.dk' && localStorage.getItem('email') !== 'info@friskmalerservice.dk') {
      // setTimeout(function () {   document.getElementById('kredit-tjek').style.display = 'none' }, 2000)
      setTimeout(function () {
        var els = document.getElementsByTagName('a')
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i]
          console.log(el.href)
          if (el.href.includes('#/visitkort')) {
            els[i].style.display = 'none'
            els[i].href = '#'
          }
          if (el.href.includes('#/inviter-en-kollega')) {
            els[i].style.display = 'none'
            els[i].href = '#'
          }
        }
      }, 500)
    }

    if (localStorage.getItem('inhouse') === '1') {
      window.addEventListener('storage', this.storageHandler, false)
    }
    if (localStorage.getItem('isshop') !== 'true') {
      setTimeout(function () {
        var element = document.getElementById('dropWebshop')
        element.style.display = 'none'
        // element = document.getElementById('dropOpret tilbud')
        // element.style.display = 'none'
      }, 500)
    }
    if (localStorage.getItem('climate') !== 'true') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a')
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i]
          if (el.href.includes('#/klima')) {
            els[i].style.display = 'none'
            els[i].href = '#'
          }
        }
      }, 500)
    }
    if (localStorage.getItem('isadmin') === 'false') {
      // console.log(localStorage.getItem('permission'))
      setTimeout(function () {
        var els = document.getElementsByTagName('a')
        var pers = JSON.parse(localStorage.getItem('permission'))
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i]
          var permission = null
          if (el.href.includes('#/newsfeed')) {
            for (var j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'newsfeed' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/markedsplads')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'marketplace' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/mester-arbejdskraft')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'm2m' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/mester-opgaver')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'm2m' && permission.value === '0') {
                var menu = document.getElementById('dropMester-til-Mester')
                menu.style.display = 'none'
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/settings')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'settings' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/alle-moeder')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'your_client' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/inbox')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'message' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/indhent-anbefalinger') || el.href.includes('#/laes-og-besvar-anbefalinger') || el.href.includes('#/auto-anbefalinger') || el.href.includes('#/widgets')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'recommendations' && permission.value === '0') {
                var menua = document.getElementById('dropAnbefalinger')
                menua.style.display = 'none'
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/opret-projekt-new')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'projects' && permission.value === '0') {
                var menup = document.getElementById('dropDine projekter')
                menup.style.display = 'none'
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/status-haandvaerker-new')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'projects' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/chat')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'chat' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/offer')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'make_an_offer' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
          if (el.href.includes('#/contact_us')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j]
              if (permission.module === 'contact_us' && permission.value === '0') {
                els[i].style.display = 'none'
                els[i].href = '#'
              }
            }
          }
        }
      }, 500)
    }
    if (localStorage.getItem('onlycredit') === '1') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a')
        for (var e = 0, r = els.length; e < r; e++) {
          if (!els[e].href.includes('#/login') && !els[e].href.includes('kredit') && !els[e].href.includes('kreditkort')) {
            els[e].style.display = 'none'
            els[e].href = '#'
          }
        }
        var element = document.getElementById('dropAnbefalinger')
        element.style.display = 'none'
        element = document.getElementById('dropDine projekter')
        element.style.display = 'none'
        element = document.getElementById('dropMester-til-Mester')
        element.style.display = 'none'
        element = document.getElementById('dropWebshop')
        element.style.display = 'none'
        element = document.getElementById('dropOpret tilbud')
        element.style.display = 'none'
      }, 500)
    }
  },
  data () {
    return {
      nav: nav.items
    }
  },
  methods: {
    storageHandler (evt) {
      if (evt.key === 'id_token_portal') {
        this.$router.push('/security')
      }
      // this.$router.push('/security')
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>



// WEBPACK FOOTER //
// Full.vue?2cf4d6dc